/**
 * Returns true if the subject is a Function.
 * @param subject
 */
export default function isFunction(subject) {
    return typeof subject === 'function';
    //return Object.prototype.toString.call(subject) === '[object Function]';
}
